import { render, staticRenderFns } from "./AuditHistoryButton.vue?vue&type=template&id=c5babb34&scoped=true"
import script from "./AuditHistoryButton.vue?vue&type=script&lang=js"
export * from "./AuditHistoryButton.vue?vue&type=script&lang=js"
import style0 from "./AuditHistoryButton.vue?vue&type=style&index=0&id=c5babb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5babb34",
  null
  
)

export default component.exports